import { useCallback } from 'react';
import { DrawerType } from '../state/Drawer/DrawerState';
import { useDrawer } from '../state/Drawer/hooks/useDrawer';
import { DisplayWebContentDrawer } from './Workflows/DisplayWebContent/DisplayWebContentDrawer';
import { TriggerDrawer } from './Workflows/Trigger/TriggerDrawer/TriggerDrawer';
import { SendEmailDrawer } from './Workflows/SendEmail/SendEmailDrawer';
import { BranchControlDrawer } from './Workflows/BranchControl/BranchControlsDrawer';
import { useWorkflowForm } from '../contexts/CampaignWorkflowFormContext';
import { FormKeys } from '../state/CampaignWorkflowFormActions';
import { SplitTestSettingsDrawer } from './Workflows/SplitTestSettings/SplitTestSettingsDrawer';
import { DisplayWebContentVariantDrawer } from './Workflows/DisplayWebContent/DisplayWebContentVariantDrawer';

const typeToFocused: { [key in DrawerType]: FormKeys } = {
  trigger: 'trigger',
  'display-website-content': undefined,
  'display-web-content-variant-settings': undefined,
  'split-test-settings': undefined,
  'send-email': undefined,
  'branch-controls': 'branchControl',
};

export const DrawerController = () => {
  const { drawer, closeDrawer } = useDrawer();
  const { actions } = useWorkflowForm();

  const onClose = useCallback(() => {
    closeDrawer();
    actions.setFocused(typeToFocused[drawer.type] ?? drawer.id, false);
  }, [actions, closeDrawer, drawer.id, drawer.type]);

  return (
    <>
      <TriggerDrawer open={drawer.type === 'trigger' && drawer.open} closeDrawer={onClose} />
      <DisplayWebContentDrawer
        open={drawer.type === 'display-website-content' && drawer.open}
        closeDrawer={onClose}
        messageId={drawer.id}
      />
      <DisplayWebContentVariantDrawer
        open={drawer.type === 'display-web-content-variant-settings' && drawer.open}
        closeDrawer={onClose}
        messageId={drawer.id}
      />
      <SplitTestSettingsDrawer
        open={drawer.type === 'split-test-settings' && drawer.open}
        closeDrawer={onClose}
        messageId={drawer.id}
      />
      <SendEmailDrawer open={drawer.type === 'send-email' && drawer.open} closeDrawer={onClose} messageId={drawer.id} />
      <BranchControlDrawer
        open={drawer.type === 'branch-controls' && drawer.open}
        closeDrawer={onClose}
        messageId={drawer.id}
      />
    </>
  );
};
